module.exports = __webpack_public_path__ + "static/img/280_TO8_2421.4ee98fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/280_TO8_2421.jpg
// module id = fIQF
// module chunks = 0